import React from 'react';
import { TabsOption } from 'global';
import { CustomerDetailsTabs } from 'modules/customers/types';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CardBackground } from 'components/CardBackground/CardBackground';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';

import {
  CustomerDetailsGeneralTab,
  CustomerDetailsDocumentsTab,
  CustomerDetailsCreditAppsTab,
  CustomerDetailsActivityHubTab,
} from './tabs';

export const CustomerDetailsPage = () => {
  const tabs: TabsOption<CustomerDetailsTabs>[] = [
    {
      label: 'General',
      value: CustomerDetailsTabs.General,
      component: <CustomerDetailsGeneralTab />,
      urlAnchor: `#${CustomerDetailsTabs.General}`,
    },
    {
      label: 'Activity Hub',
      value: CustomerDetailsTabs.ActivityHub,
      component: <CustomerDetailsActivityHubTab />,
      urlAnchor: `#${CustomerDetailsTabs.ActivityHub}`,
    },
    {
      label: 'Documents',
      value: CustomerDetailsTabs.Documents,
      component: <CustomerDetailsDocumentsTab />,
      urlAnchor: `#${CustomerDetailsTabs.Documents}`,
    },
    {
      label: 'Credit Apps',
      value: CustomerDetailsTabs.CreditApps,
      component: <CustomerDetailsCreditAppsTab />,
      urlAnchor: `#${CustomerDetailsTabs.CreditApps}`,
    },
  ];

  return (
    <PageContainer>
      <TabsContainer<CustomerDetailsTabs> tabs={tabs} TabsLabelWrapper={CardBackground} isSyncWithAnchor />
    </PageContainer>
  );
};
